// extracted by mini-css-extract-plugin
export default {"add_client_btn":"AddButton_add_client_btn__+lBJ3","addicon":"AddButton_addicon__G6LFc","text_wrapper":"AddButton_text_wrapper__cufzs"};